import api from "@/lib/api";

export const orgKnowledgeService = {
  list: () => api.get("/org/knowledge").then((r) => r.data.documents),
  upload: (file) => {
    const form = new FormData();
    form.append("file", file);
    return api.post("/org/knowledge/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data.document);
  },
  remove: (id) => api.delete(`/org/knowledge/${id}`).then((r) => r.data),
  bulkGenerate: (payload) => api.post("/org/knowledge/bulk-generate", payload).then((r) => r.data.job),
  jobs: () => api.get("/org/knowledge/jobs").then((r) => r.data.jobs),
};
